import { TableSchema } from '../metadata-schema';

export const dim_kl_klas: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_kl_klas",
	"description": "Definitie voor dimension tabel dim_kl_klas uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Vestigingspecifiek"
	],
	"properties": {
		"kl_id_vestiging": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		},
		"kl_nm_klas": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"allowlist": {
				"beheer": true
			}
		}
	}
};
